import React from "react";
import {
  HubSpotMeetingProvider,
  useGlobalHubSpotMeeting,
} from "@/contexts/HubSpotMeetingContext";

/**
 * @deprecated Compatibility layer for legacy pages.
 * Use HubSpotMeetingProvider / useGlobalHubSpotMeeting in new code.
 */
export const CalendlyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <HubSpotMeetingProvider>{children}</HubSpotMeetingProvider>
);

/** @deprecated Use useGlobalHubSpotMeeting instead. */
export const useGlobalCalendly = () => {
  const { isHubSpotMeetingOpen, openHubSpotMeeting, closeHubSpotMeeting } = useGlobalHubSpotMeeting();

  return {
    isCalendlyOpen: isHubSpotMeetingOpen,
    openCalendly: openHubSpotMeeting,
    closeCalendly: closeHubSpotMeeting,
  };
};
